import { Box } from '@mui/material';
import ApplicantDashboard from './components/ApplicantDashboard';
import ApplicationWizard from './components/ApplicationWizard';
import { Route, Switch, useRouteMatch } from 'react-router';

interface PropsType {
  mainRef: any;
}

/**
 * Main placeholder landing page for Applicants UI
 * @param props
 * @returns
 */
export default function Applications(props: PropsType) {
  let { path} = useRouteMatch();
  
  return (
    <Box>
      <Switch>
        <Route exact path={path}>
          <ApplicantDashboard />
        </Route>
        <Route path={`${path}/:id`}>
          <ApplicationWizard />
        </Route>
      </Switch>
    </Box>
  );
}
